export default __webpack_public_path__ + "4e9858ce8bd3abbe221631ca438e710e.png";